// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"591":"4b9e939f","736":"9d6bbd7b","805":"73c7f0b9"}[chunkId] + ".chunk.css";
};